const FAQs = [
    {
        title: "What are Bubblery Gift Cards?",
        desc: "Bubblery Gift Cards are prepaid cards that can be used to purchase drinks and treats at any of our Bubblery locations or on our online store."
    },
    {
        title: "How can I purchase a Bubblery Gift Card?",
        desc: "You can purchase Bubblery Gift Cards in-store at any of our locations or online through our website."
    },
    {
        title: "What amounts are available for Bubblery Gift Cards?",
        desc: "Bubblery Gift Cards are available in various denominations, allowing you to choose the amount that best fits your gifting needs."
    },
    {
        title: "Can I reload my Bubblery Gift Card?",
        desc: "Yes, you can reload your Bubblery Gift Card with additional funds at any of our locations or online."
    },
    {
        title: "Can I use my Bubblery Gift Card for online orders?",
        desc: "Yes, Bubblery Gift Cards can be used for purchases made both in-store and online."
    },
    {
        title: "Can I check the balance of my Bubblery Gift Card?",
        desc: "Yes, you can easily check the balance of your Bubblery Gift Card online or by visiting any of our locations."
    },
    {
        title: "Do Bubblery Gift Cards expire?",
        desc: "No, Bubblery Gift Cards do not have an expiration date, so you can enjoy your favorite drinks and treats at your own pace."
    },
    {
        title: "Can I redeem multiple Bubblery Gift Cards for a single purchase?",
        desc: "Yes, you can use multiple Bubblery Gift Cards to pay for your purchase, making them a great option for group gifts or splitting the bill."
    },
    {
        title: "Can I purchase a Bubblery Gift Card as a gift for someone else?",
        desc: "Absolutely! Bubblery Gift Cards make the perfect gift for any occasion, allowing your friends and loved ones to indulge in their favorite drinks and treats at Bubblery."
    },
    {
        title: "Can I return or refund a Bubblery Gift Card?",
        desc: "No, Bubblery Gift Cards are non-refundable and cannot be exchanged for cash. However, they can be used to purchase any of our delicious drinks and treats."
    },
    {
        title: "Are there any fees associated with Bubblery Gift Cards?",
        desc: "No, there are no fees associated with Bubblery Gift Cards. The full value of the card goes towards purchasing your favorite Bubblery treats."
    }
]


export default FAQs;